import ReactGA from 'react-ga4';

export enum GoogleTagManagerActions {
  // SIM products - activation/deactivation
  SingleSimProductActivationSuccess = 'single_sim_product_activation_success',
  SingleSimProductActivationFailure = 'single_sim_product_activation_failure',
  SingleSimProductDeactivationSuccess = 'single_sim_product_deactivation_success',
  SingleSimProductDectivationFailure = 'single_sim_product_deactivation_failure',

  MultipleSimProductActivationSuccess = 'multiple_sim_product_activation_success',
  MultipleSimProductActivationFailure = 'multiple_sim_product_activation_failure',
  MultipleSimProductDeactivationSuccess = 'multiple_sim_product_deactivation_success',
  MultipleSimProductDectivationFailure = 'multiple_sim_product_deactivation_failure',

  // RSIM products - activation/deactivation
  SingleRSimProductActivationSuccess = 'single_rsim_product_activation_success',
  SingleRSimProductActivationFailure = 'single_rsim_product_activation_failure',
  SingleRSimProductDeactivationSuccess = 'single_rsim_product_deactivation_success',
  SingleRSimProductDeactivationFailure = 'single_rsim_product_deactivation_failure',

  MultipleRSimProductActivationSuccess = 'multiple_rsim_product_activation_success',
  MultipleRSimProductActivationFailure = 'multiple_rsim_product_activation_failure',
  MultipleRSimProductDeactivationSuccess = 'multiple_rsim_product_deactivation_success',
  MultipleRSimProductDectivationFailure = 'multiple_rsim_product_deactivation_failure',

  // SIM products - export
  InitialSimProductExportFailure = 'initial_sim_product_export_failure',
  SmallSimProductExportSuccess = 'small_sim_product_export_success',
  SmallSimProductExportFailure = 'small_sim_product_export_failure',
  LargeSimProductExportSuccess = 'large_sim_product_export_success',
  LargeSimProductExportFailure = 'large_sim_product_export_failure',

  // RSIM products - export
  InitialRSimProductExportFailure = 'initial_rsim_product_export_failure',
  SmallRSimProductExportSuccess = 'small_rsim_product_export_success',
  SmallRSimProductExportFailure = 'small_rsim_product_export_failure',
  LargeRSimProductExportSuccess = 'large_rsim_product_export_success',
  LargeRSimProductExportFailure = 'large_rsim_product_export_failure',

  // SIM profiles - export
  InitialSimProfileExportFailure = 'initial_sim_profile_export_failue',
  SmallSimProfileExportSuccess = 'small_sim_profile_export_success',
  SmallSimProfileExportFailure = 'small_sim_profile_export_failure',
  LargeSimProfileExportSuccess = 'large_sim_profile_export_success',
  LargeSimProfileExportFailure = 'large_sim_profile_export_failure',

  // Downloads/Uploads
  DownloadMasterTemplate = 'download_master_template',
  DownloadBulkProvisioning = 'download_bulk_provisioning',
  DownloadUnitDataAdjustment = 'download_unit_data_adjustment',
  DownloadSimProfileManagement = 'download_sim_profile_management',
  UploadFileSuccess = 'upload_file_success',
  UploadFileFailure = 'upload_file_failure',

  // Other
  ErrorPageLinkUnavailableOrExpired = 'error_page_link_unavailable_or_expired',
}

export const sendGoogleTagManagerAction = (eventName: string) => {
  if (ReactGA.isInitialized) {
    ReactGA.event({
      action: 'USER ACTION',
      category: eventName,
    });
  }
};
